export enum AuthorisationStatus {
  Active = 1,
  Complete = 2,
  Rejected = 3,
}
